import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { EducationReportSelfAssessmentForm } from "../../../components/report/selfAssessment/EducationReportSelfAssessmentForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { EducationReport } from "../../../models/reports/educationReport";
import type { EducationReportTranslations } from "../../../models/reports/educationReportTranslations";
import {
  apprentice_documents_path,
  apprentice_report_complete_self_assessment_path,
  apprentice_report_save_self_assessment_path,
} from "../../../routes";

type EducationReportSelfAssesment = {
  education_report: EducationReport;
  education_report_translations: EducationReportTranslations;
  apprentice_id: number;
};

export default function EducationReportSelfAssessment({
  education_report,
  education_report_translations,
  apprentice_id,
}: EducationReportSelfAssesment) {
  const { pathWithYearContext } = useYearContext();
  const onSave = (values: RequestPayload) =>
    router.patch(pathWithYearContext(apprentice_report_save_self_assessment_path, apprentice_id, education_report.id), values);
  const onComplete = (values: RequestPayload) =>
    router.patch(pathWithYearContext(apprentice_report_complete_self_assessment_path, apprentice_id, education_report.id), values);

  return (
    <ContentShell
      title={`Selbsteinschätzung ${education_report.title}`}
      onBack={() => router.get(pathWithYearContext(apprentice_documents_path, apprentice_id))}
    >
      <EducationReportSelfAssessmentForm
        onComplete={onComplete}
        onSave={onSave}
        educationReport={education_report}
        translations={education_report_translations}
      />
    </ContentShell>
  );
}
